/** @module csi/widget/_svg/TypePlaceholder */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton, locale, _Plugin, PluginFactory, util) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle",
		materialIcon: "art_track",
		pluginName: "typePlaceholder",
		title: "CanvasPlaceholder",

		/**
		 * Only show plugin for canvas templates as well as style BOM when in edit mode
		 * @return {boolean}
		 */
		canShowPlugin: function() {
			const view = this.getView();
			return (!!this.editor.editMode && (view.isCanvasTemplate() || view.isStyleBOM()));
		},

		/**
		 * Show the add attribute placeholder dialog
		 */
		onClick: function() {
			var actionWidget = this;
			var editor = this.editor;

			editor.setNoDrawMode();

			this.getView().insertAttributePlaceholder({
				onEnd: function() {
					// ensure that after adding a placeholder or clicking cancel, the add placeholder
					// button is not depressed, and the select button is depressed
					actionWidget.set("checked", false);

					if (!this.endStatus) {
						editor.canvasApp.canvasApi().setCanvasMode(util.canvasModes.SELECT);
					}
				}
			});
		}
	});
});
